import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { portfolio } from '../services/api';

export const AutoWeeklyPdfDigestConfig: React.FC = () => {
  const { language } = useLanguage();
  const [email, setEmail] = useState('invest@anogilimited.com');
  const [frequency, setFrequency] = useState('friday_noon');
  const [isEnabled, setIsEnabled] = useState(true);
  const [savedStatus, setSavedStatus] = useState(false);
  const [isSendingTest, setIsSendingTest] = useState(false);
  const [testResult, setTestResult] = useState<string | null>(null);

  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    setSavedStatus(true);
    setTimeout(() => setSavedStatus(false), 3000);
  };

  const handleSendTestNow = async () => {
    setIsSendingTest(true);
    setTestResult(null);
    try {
      const res = await portfolio.sendDailyReport(email);
      setTestResult(res.data?.message || (language === 'sk' ? 'Report úspešne odoslaný!' : 'Report sent successfully!'));
    } catch (err: any) {
      setTestResult(err.response?.data?.error || err.message || (language === 'sk' ? 'Odoslanie zlyhalo' : 'Failed to send'));
    } finally {
      setIsSendingTest(false);
      setTimeout(() => setTestResult(null), 5000);
    }
  };

  return (
    <div className="glass-panel p-6 space-y-4 font-mono">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 pb-3 border-b border-[var(--border-color)]">
        <div>
          <h3 className="text-sm font-extrabold uppercase tracking-widest text-slate-900 flex items-center gap-2">
            <span>📑</span>
            {language === 'sk' ? 'Automatické Týždenné PDF Výpisy' : 'Automated Weekly PDF Reports'}
          </h3>
          <p className="text-[10px] text-slate-500 mt-0.5">
            {language === 'sk' 
              ? 'Každý piatok o 12:00 Vám systém automaticky doručí auditovaný PDF výkaz majetku a pozícií' 
              : 'System automatically dispatches audited PDF valuation and holdings report every Friday at 12:00 PM'}
          </p>
        </div>

        <div className="flex items-center gap-2">
          <span className={`text-[9px] font-extrabold px-2.5 py-1 rounded-full border ${
            isEnabled ? 'bg-emerald-50 text-emerald-800 border-emerald-300' : 'bg-slate-100 text-slate-600 border-slate-300'
          }`}>
            {isEnabled ? (language === 'sk' ? '🟢 AKTÍVNE (PIATOK 12:00)' : '🟢 ACTIVE (FRIDAY 12:00 PM)') : (language === 'sk' ? '⚪ VYPNUTÉ' : '⚪ DISABLED')}
          </span>
        </div>
      </div>

      <form onSubmit={handleSave} className="grid grid-cols-1 sm:grid-cols-4 gap-3 text-xs">
        <div>
          <label className="block text-[9px] uppercase font-extrabold text-slate-500 mb-1">
            {language === 'sk' ? 'Doručovací Email' : 'Recipient Email'}
          </label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-white border border-slate-300 rounded-xl p-2 font-bold outline-none text-slate-900"
          />
        </div>

        <div>
          <label className="block text-[9px] uppercase font-extrabold text-slate-500 mb-1">
            {language === 'sk' ? 'Frekvencia Odosielania' : 'Schedule Frequency'}
          </label>
          <select
            value={frequency}
            onChange={(e) => setFrequency(e.target.value)}
            className="w-full bg-white border border-slate-300 rounded-xl p-2 font-bold outline-none text-slate-900"
          >
            <option value="friday_noon">{language === 'sk' ? 'Každý piatok (12:00)' : 'Every Friday (12:00 PM)'}</option>
            <option value="daily_morning">{language === 'sk' ? 'Každý deň ráno (07:30)' : 'Every Day Morning (07:30 AM)'}</option>
            <option value="monday_8am">{language === 'sk' ? 'Pondelok ráno (08:00)' : 'Every Monday Morning (08:00 AM)'}</option>
            <option value="monthly">{language === 'sk' ? '1. deň v mesiaci' : 'First Day of Month'}</option>
          </select>
        </div>

        <div className="flex items-end">
          <button
            type="submit"
            className="w-full py-2 px-4 rounded-xl text-xs font-black bg-slate-900 text-white hover:opacity-90 transition-all shadow-sm flex items-center justify-center gap-1.5"
          >
            <span>💾</span>
            <span>{savedStatus ? (language === 'sk' ? 'Uložené!' : 'Saved!') : (language === 'sk' ? 'Uložiť Plán' : 'Save Plan')}</span>
          </button>
        </div>

        <div className="flex items-end">
          <button
            type="button"
            onClick={handleSendTestNow}
            disabled={isSendingTest}
            className="w-full py-2 px-4 rounded-xl text-xs font-black bg-emerald-700 hover:bg-emerald-800 text-white transition-all shadow-sm flex items-center justify-center gap-1.5 disabled:opacity-50"
          >
            <span>🚀</span>
            <span>{isSendingTest ? (language === 'sk' ? 'Odosielam...' : 'Sending...') : (language === 'sk' ? 'Odoslať Ihneď Test' : 'Send Test Now')}</span>
          </button>
        </div>
      </form>

      {testResult && (
        <div className={`p-3 rounded-xl text-xs font-bold ${
          testResult.toLowerCase().includes('úspešne') || testResult.toLowerCase().includes('success')
            ? 'bg-emerald-50 text-emerald-800 border border-emerald-200'
            : 'bg-rose-50 text-rose-800 border border-rose-200'
        }`}>
          {testResult}
        </div>
      )}
    </div>
  );
};
